/**
 * @function isAnimationSupported
 * @memberof Promega.Util
 * @description Determines if the current browser can support CSS3 animations using the native (non vendor-prefixed) syntax.
 * @returns {Boolean} True if standard CSS3 animation is supported; otherwise, false.
 */
export default function isAnimationSupported () {
	return document.documentElement.style.animationName !== undefined;
}
